import { environment } from '../../environments/environment';

export function logoUrl(userId: string | null | undefined, bust = false): string | null {
  if (!userId) return null;
  return `${environment.apiUrl}/auth/logo/${userId}${bust ? `?t=${Date.now()}` : ''}`;
}
